// Global attachment preview cache
// Prevents duplicate Storage GET requests across the entire app
const CACHE_DURATION = 50 * 60 * 1000; // 50 minutes

class AttachmentPreviewCache {
    constructor() {
        this.cache = new Map();
        this.loading = new Set();
        this.listeners = new Map();
    }

    isExpired(timestamp) {
        return Date.now() - timestamp > CACHE_DURATION;
    }

    get(storagePath) {
        const entry = this.cache.get(storagePath);
        if (entry && !this.isExpired(entry.timestamp)) {
            return entry;
        }
        if (entry) {
            this.cache.delete(storagePath); // Remove expired
        }
        return null;
    }

    set(storagePath, entry) {
        this.cache.set(storagePath, entry);
        this.notifyListeners(storagePath, entry);
    }

    isLoading(storagePath) {
        return this.loading.has(storagePath);
    }

    setLoading(storagePath, loading) {
        if (loading) {
            this.loading.add(storagePath);
        } else {
            this.loading.delete(storagePath);
        }
    }

    subscribe(storagePath, callback) {
        if (!this.listeners.has(storagePath)) {
            this.listeners.set(storagePath, new Set());
        }
        this.listeners.get(storagePath).add(callback);

        // Send current value immediately
        const current = this.get(storagePath);
        if (current) {
            callback(current);
        }

        return () => {
            const listeners = this.listeners.get(storagePath);
            if (listeners) {
                listeners.delete(callback);
                if (listeners.size === 0) {
                    this.listeners.delete(storagePath);
                }
            }
        };
    }

    notifyListeners(storagePath, entry) {
        const listeners = this.listeners.get(storagePath);
        if (listeners) {
            listeners.forEach(callback => callback(entry));
        }
    }

    clear() {
        this.cache.clear();
        this.loading.clear();
        this.listeners.clear();
    }
}

export const attachmentPreviewCache = new AttachmentPreviewCache();